<template>
  <div class="research_wrap">
    <!-- 直接显示图片和文字 -->
    <div class="banner_section hidden-xs-only">
      <img :src="localizedImgList[0].src" alt="" class="banner_img" />
    </div>
         <h1 class="page_title">{{ localizedImgList[0].line1 }}</h1>
    <div class="research_card hidden-xs-only">
      <div class="research-left">
        <div class="top-blue-bar"></div>

        <div class="table-wrap">
          <table class="category-table">
            <thead>
              <tr>
                <th colspan="3">{{ $t('ssccpPage.groupTitle1') }}</th>
                <th colspan="6">{{ $t('ssccpPage.groupTitle2') }}</th>
              </tr>
              <tr>
                <th v-for="(category, index) in $t('ssccpPage.purchaseCategories')" :key="index">
                  {{ category.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rowIndex in maxRowCount" :key="rowIndex">
                <td v-for="category in $t('ssccpPage.purchaseCategories')" :key="category.title">
                  {{ category.items[rowIndex - 1] || '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="data-platform">
          <div class="data-left">{{ $t('ssccpPage.dataLeft') }}</div>
          <div class="data-right">
            <div class="row" v-for="(row, rIndex) in $t('ssccpPage.dataRight')" :key="rIndex">
              <div v-for="(item, i) in row" :key="i">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="research_sp_wrap_mobile hidden-sm-and-up">
      <div class="research-left">
        <div class="top-blue-bar"></div>

        <div class="table-wrap">
          <table class="category-table">
            <thead>
              <tr>
                <th colspan="3">环境</th>
                <th colspan="6">合规和可持续</th>
              </tr>
              <tr>
                <th v-for="(category, index) in $t('ssccpPage.purchaseCategories')" :key="index">
                  {{ category.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rowIndex in maxRowCount" :key="rowIndex">
                <td v-for="category in $t('ssccpPage.purchaseCategories')" :key="category.title">
                  {{ category.items[rowIndex - 1] || '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="data-platform">
          <div class="data-left">供应链中台</div>
          <div class="data-right">
            <div class="row" v-for="(row, rIndex) in $t('ssccpPage.dataRight')" :key="rIndex">
              <div v-for="(item, i) in row" :key="i">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme style="margin-top: 130px;" />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index';
import MobileCallme from '@/components/callme/MobileCallme.vue';

export default {
  data() {
    return {
      purchaseCategories: [
        { title: '低碳类', items: ['ISO14064碳核算', 'ISO14067碳足迹', 'ISO14068碳中和', 'LCA生命周期评价', 'ISCC PLUS/EU', 'CBAM欧盟碳关税'] },
        { title: '能源类', items: ['ISO50001能源体系', '能源审计/诊断', '专项能效测试', '电/水/热平衡测试', '节能评估服务'] },
        { title: '绿建类', items: ['EPD环境产品声明', 'ISO14046水足迹', 'LEED绿色建筑', 'WELL健康建筑', '中国绿建'] },
        { title: '合规生产类', items: ['ISO14001环境体系', '绿色工厂', '零碳工厂', '绿色供应链'] },
        { title: '追溯管理类', items: ['供应链EHS审核', 'FSC森林认证', 'EUDR欧盟塑料链', 'GRS全球回收标准', '废弃物零填埋体系', '欧盟电池法案', 'ISO20400可持续采购'] },
        { title: '社会责任类', items: ['ESG报告编制', 'ESG现状评估分析', 'CDP环境信息披露', 'EcoVadis评分提升', 'EWB员工满意调查', 'SA8000社会责任'] },
        { title: '健康和安全类', items: ['ISO45001', '电气安全评估', '消防安全评估', '建筑施工安全辅导', 'HS法律法规清单', 'HS合规评价'] },
        { title: '合规风险类', items: ['ISO27001信息安全', 'ISO22301业务连续性', 'ISO37301合规管理体系', 'ISO31000风险管理'] },
        { title: '能力建设类', items: ['欧盟电池法规', 'CBAM欧盟碳关税', '双碳法规政策解读', '节能评估师', '定制化培训训练营'] }
      ]
    };
  },
  computed: {
    localizedImgList() {
      return [
        {
          src: require('@/assets/img/hly/new2/gyl-new-bg1.png'),
          line1: this.$t('ssccpPage.carousel.line1'),
          line2: this.$t('ssccpPage.carousel.line2')
        }
      ];
    },
    maxRowCount() {
      return Math.max(...this.purchaseCategories.map(cat => cat.items.length));
    },
    industries() {
      return [
            { label: this.$t('ssccpPage.industries[0]'), icon: require('@/assets/img/card/item1.png') },
            { label: this.$t('ssccpPage.industries[1]'), icon: require('@/assets/img/card/item2.png') },
            { label: this.$t('ssccpPage.industries[2]'), icon: require('@/assets/img/card/item3.png') },
            { label: this.$t('ssccpPage.industries[3]'), icon: require('@/assets/img/card/item4.png') },
            { label: this.$t('ssccpPage.industries[4]'), icon: require('@/assets/img/card/item5.png') },
            { label: this.$t('ssccpPage.industries[5]'), icon: require('@/assets/img/card/item6.png') },
            { label: this.$t('ssccpPage.industries[6]'), icon: require('@/assets/img/card/item7.png') },
            { label: this.$t('ssccpPage.industries[7]'), icon: require('@/assets/img/card/item8.png') }
          ];
    }
  },
  components: {
    CallMe,
    MobileCallme
  }
};
</script>

<style lang="scss" scoped>
.research_wrap {
  position: relative;
  width: 100%;

  .banner_section {
    position: relative;
    width: 100%;
    height: 23vw;
    overflow: hidden;
  }

  .banner_img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    // background-color: #f5f5f5;
  }

  .page_title {
    text-align: center;
    font-size: 36px;
    color: #0091ff;
    font-weight: bold;
    margin: -20px 0 40px 0;
    
    @media screen and (max-width: 768px) {
      font-size: 24px;
    }
  }

  .banner_text {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    color: #fff;
    text-align: center;
    
    h1 {
      font-size: 25px;
      margin: 10px 0;
      
      @media screen and (max-width: 768px) {
        font-size: 18px;
      }
    }
  }

  .table-wrap {
    overflow-x: auto;
    margin-top: 30px;

    @media screen and (max-width: 768px) {
      margin-top: 15px;
      -webkit-overflow-scrolling: touch;
    }
  }

  .category-table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    background-color: #fff;
    th {
      font-size: 18px;
      background-color: #fff;
      font-weight: bold;
      color: #1c7de6;
      border: 1px solid #ccc;
      padding: 10px;
      vertical-align: top;

      @media screen and (max-width: 768px) {
        font-size: 14px;
        padding: 6px;
        min-width: 120px;
      }
    }

    td {
      font-size: 15px;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-top: none;
      border-bottom: none;
      padding: 10px;
      vertical-align: top;

      @media screen and (max-width: 768px) {
        font-size: 12px;
        padding: 6px;
      }
    }
  }

  .data-platform {
    display: flex;
    margin-top: 0px;
    background: #f9f9f9;
    border: 1px solid #ddd;

    .data-left {
      font-size: 16px;
      color: #1c7de6;
      background: #fff;
      padding: 20px;
      width: 20%;
      font-weight: bold;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #ccc;

      @media screen and (max-width: 768px) {
        width: 35%;
        font-size: 14px;
        padding: 12px;
      }
    }

    .data-right {
      width: 80%;
      padding: 20px;
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 768px) {
        width: 65%;
        padding: 12px;
      }

      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        @media screen and (max-width: 768px) {
          flex-direction: column;
          margin-bottom: 8px;
        }

        div {
          flex: 1;
          text-align: center;
          font-size: 18px;
          padding: 8px;
          border: 1px dashed #ccc;
          margin: 0 5px;
          background: #fff;

          @media screen and (max-width: 768px) {
            font-size: 14px;
            padding: 6px;
            margin: 4px 0;
          }
        }
      }
    }
  }

  .research-left {
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    background-color: #ecf6fe;
    /* 适配移动端padding调整 */
    padding: 10px;

    @media screen and (max-width: 768px) {
      padding: 8px;
    }
  }

  .top-blue-bar {
    width: 100%;
    height: 40px;
    background-color: #0091ff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    @media screen and (max-width: 768px) {
      height: 25px;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }
  }

  .industry-row {
    display: flex;
    flex-wrap: wrap;
    gap: 60px;
    justify-content: center;
    margin: 30px 0;

    @media screen and (max-width: 768px) {
      gap: 12px;
      margin: 20px 0;
    }

    .industry-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 80px;

      @media screen and (max-width: 768px) {
        width: 60px;
      }

      img {
        width: 40px;
        height: 40px;
        margin-bottom: 8px;

        @media screen and (max-width: 768px) {
          width: 30px;
          height: 30px;
          margin-bottom: 6px;
        }
      }

      span {
        font-size: 18px;
        color: #333;

        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
  }

  .research_card {
    background: #ffffff;
    border-radius: 12px;
    padding: 40px;
    margin-top: -50px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    z-index: 5;
    position: relative;

    @media screen and (max-width: 768px) {
      padding: 20px;
      margin-top: -100px;
      width: 90%;
    }
  }
}
</style>

